/*
 * File: OrderNote.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 08/21/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays an individual order note
 */

import React from "react";
import PropTypes from "prop-types";
import UIListItem from "components/ui/UIListItem";
import { format } from "date-fns";

const OrderNote = ({ orderNoteModel }) => {
  return (
    <React.Fragment>
      <UIListItem label={orderNoteModel.message} divider={false} />
      <UIListItem
        label={"Created"}
        value={format(orderNoteModel.created, "MM/dd/yyyy hh:mm a")}
        divider={false}
      />
      <UIListItem
        label={"Assigned: "}
        value={`${orderNoteModel.assignedToFirst} ${orderNoteModel.assignedToLast}`}
      />
      <UIListItem
        label={"Author: "}
        value={`${orderNoteModel.authorFirst} ${orderNoteModel.authorLast}`}
      />
    </React.Fragment>
  );
};

OrderNote.propTypes = {
  orderNoteModel: PropTypes.object.isRequired
};

export default OrderNote;
